import { Injectable } from '@angular/core';
import { directus, authLocalStorage } from '../../../directus';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isAuthenticated = false;

  constructor() {
    this.isAuthenticated = !!localStorage.getItem(environment.directus_storage);
   // if (this.isAuthenticated) {
   //   try {
   //     directus.refresh();
//
   //   } catch (error) {
   //     console.error("========================= AuthService constructor directus.refresh()", error);
   //     this.isAuthenticated = false;
   //   }
   // }
  }

  async login(email: string, password: string): Promise<boolean> {
    try {
      const _login = await directus.login(email, password);
      //await directus.refresh();
      //await directus.logout();
      console.log(' ============== AuthService login ' + _login);
      if (_login && _login.access_token) {
        this.isAuthenticated = true;
      } else {
        this.isAuthenticated = false;
      }

    } catch (error) {
      alert("Autenticazione fallita: "+ error)
      console.error("Authentication failed:", error);
      this.isAuthenticated = false;
    }
    return this.isAuthenticated;
  }

  isAuthenticatedUser(): boolean {
    //console.log("Authentication isAuthenticatedUser:", this.isAuthenticated);
    return this.isAuthenticated;
  }

  logout(): void {
    directus.logout();
    this.isAuthenticated = false;
  }
}
